﻿const pseudoElement = {
  init: function() {
    this.header = document.getElementById("header")
    this.sticky = document.querySelector("#subnav") === null ? document.getElementById("main-nav") : document.getElementById("subnav")
    this.elementHeight = this.sticky.offsetHeight;
    this.header.setAttribute("data-height", this.elementHeight)

    this.pseudoElement = document.createElement("div")
    this.pseudoElement.setAttribute("id", "pseudo")
    this.pseudoElement.setAttribute("style", `height: ${this.elementHeight}px`)
    this.header.append(this.pseudoElement)

    window.addEventListener("scroll", () => {
      if (window.innerWidth > 991) {
        var elementTarget = 300;

        if (window.scrollY > elementTarget) {
          this.pseudoElement.style.position = "static";
        } else {
          this.pseudoElement.style.position = null;
        }
      }
    });
  },
};

export default pseudoElement.init();
